import { render, staticRenderFns } from "./visits.vue?vue&type=template&id=504a1242&scoped=true"
import script from "./visits.vue?vue&type=script&lang=js"
export * from "./visits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504a1242",
  null
  
)

export default component.exports